import { render, staticRenderFns } from "./CanvasFilter.vue?vue&type=template&id=0be6644b&scoped=true&"
import script from "./CanvasFilter.vue?vue&type=script&lang=js&"
export * from "./CanvasFilter.vue?vue&type=script&lang=js&"
import style0 from "./CanvasFilter.vue?vue&type=style&index=0&id=0be6644b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6644b",
  null
  
)

export default component.exports